import { Typography } from '@mui/material';
import { useShowContext } from 'framework/show';
import { FieldProps, TextField } from 'framework/ui/field';
import { isStatusAllowed } from 'domain/shared/core/lastTouchHelpers';

const OLD_LEAD_AGE = 60;

export const NOT_AVAILABLE_LEAD_AGE = 2147483647;
// If lead has this value as a lead age, that means its age is unavailable.
// The point of that is to sort leads with unavailable age to the end of the list.

const LeadAgeField = ({
  value: inputValue = null,
  status: inputStatus = null,
  source,
  skipStates = null,
}: FieldProps) => {
  const { data } = useShowContext();
  const value = inputValue || (data && data.getValueBySource(source!));
  const status = inputStatus || (data && data.getValueBySource('status'));

  let text;
  if (value < NOT_AVAILABLE_LEAD_AGE) {
    text = `${value} d`;
  } else {
    text = 'Not Available';
  }
  const isOldLead =
    value >= OLD_LEAD_AGE &&
    value < NOT_AVAILABLE_LEAD_AGE &&
    (status === 'NEW' || status === 'OPEN' || status === 'ASSIGNED');
  let element: any = (
    <Typography
      component="span"
      variant="inherit"
      data-lead-age={isOldLead ? 'old' : 'current'}
      sx={isOldLead ? { color: 'error.main' } : undefined}
    >
      {text}
    </Typography>
  );

  if (skipStates && !isStatusAllowed(status, skipStates)) {
    element = null;
  }

  return <TextField value={element} label="Lead age" />;
};

export default LeadAgeField;
